export const premiseTypes = [
  { label: "Building", value: "BLDG" },
  { label: "Duplex", value: "DUP" },
  { label: "Factory", value: "FY" },
  { label: "Kiosk", value: "KSK" },
  { label: "Office", value: "OFF" },
  { label: "Shed", value: "SHED" },
  { label: "Shop", value: "Shop" }, //TO UPDATE
  { label: "Site", value: "Site" }, //TO UPDATE
  { label: "Suite", value: "Suite" }, //TO UPDATE
  { label: "Tenancy", value: "TNCY" },
  { label: "Unit", value: "U" },
  { label: "Warehouse", value: "Warehouse" }, //TO UPDATE
];
export const streetTypes = [
  { label: "Avenue", value: "Avenue" },
  { label: "Boulevard", value: "Boulevard" },
  { label: "Court", value: "Court" },
  { label: "Drive", value: "Drive" },
  { label: "Road", value: "Road" },
  { label: "Street", value: "Street" },
  {
    label: "Access",
    value: "Access",
  },
  {
    label: "Alley",
    value: "Alley",
  },
  {
    label: "Alleyway",
    value: "Alleyway",
  },
  {
    label: "Amble",
    value: "Amble",
  },
  {
    label: "Anchorage",
    value: "Anchorage",
  },
  {
    label: "Approach",
    value: "Approach",
  },
  {
    label: "Arcade",
    value: "Arcade",
  },
  {
    label: "Artery",
    value: "Artery",
  },
  {
    label: "Basin",
    value: "Basin",
  },
  {
    label: "Beach",
    value: "Beach",
  },
  {
    label: "Bend",
    value: "Bend",
  },
  {
    label: "Block",
    value: "Block",
  },

  {
    label: "Brace",
    value: "Brace",
  },
  {
    label: "Brae",
    value: "Brae",
  },
  {
    label: "Break",
    value: "Break",
  },
  {
    label: "Bridge",
    value: "Bridge",
  },
  {
    label: "Broadway",
    value: "Broadway",
  },
  {
    label: "Brow",
    value: "Brow",
  },
  {
    label: "Bypass",
    value: "Bypass",
  },
  {
    label: "Byway",
    value: "Byway",
  },
  {
    label: "Causeway",
    value: "Causeway",
  },
  {
    label: "Centre",
    value: "Centre",
  },
  {
    label: "Centreway",
    value: "Centreway",
  },
  {
    label: "Chase",
    value: "Chase",
  },
  {
    label: "Circle",
    value: "Circle",
  },
  {
    label: "Circlet",
    value: "Circlet",
  },
  {
    label: "Circuit",
    value: "Circuit",
  },
  {
    label: "Circus",
    value: "Circus",
  },
  {
    label: "Close",
    value: "Close",
  },
  {
    label: "Colonnade",
    value: "Colonnade",
  },
  {
    label: "Common",
    value: "Common",
  },
  {
    label: "Concourse",
    value: "Concourse",
  },
  {
    label: "Copse",
    value: "Copse",
  },
  {
    label: "Corner",
    value: "Corner",
  },
  {
    label: "Corso",
    value: "Corso",
  },
  {
    label: "Courtyard",
    value: "Courtyard",
  },
  {
    label: "Cove",
    value: "Cove",
  },
  {
    label: "Crescent",
    value: "Crescent",
  },
  {
    label: "Crest",
    value: "Crest",
  },
  {
    label: "Cross",
    value: "Cross",
  },
  {
    label: "Crossing",
    value: "Crossing",
  },
  {
    label: "Crossroad",
    value: "Crossroad",
  },
  {
    label: "Crossway",
    value: "Crossway",
  },
  {
    label: "Cruiseway",
    value: "Cruiseway",
  },
  {
    label: "Cul-De-Sac",
    value: "Cul-De-Sac",
  },
  {
    label: "Cutting",
    value: "Cutting",
  },
  {
    label: "Dale",
    value: "Dale",
  },
  {
    label: "Dell",
    value: "Dell",
  },
  {
    label: "Deviation",
    value: "Deviation",
  },
  {
    label: "Dip",
    value: "Dip",
  },
  {
    label: "Distributor",
    value: "Distributor",
  },

  {
    label: "Driveway",
    value: "Driveway",
  },
  {
    label: "Edge",
    value: "Edge",
  },
  {
    label: "Elbow",
    value: "Elbow",
  },
  {
    label: "End",
    value: "End",
  },
  {
    label: "Entrance",
    value: "Entrance",
  },
  {
    label: "Esplanade",
    value: "Esplanade",
  },
  {
    label: "Estate",
    value: "Estate",
  },
  {
    label: "Expressway",
    value: "Expressway",
  },
  {
    label: "Extension",
    value: "Extension",
  },
  {
    label: "Fairway",
    value: "Fairway",
  },
  {
    label: "Fire track",
    value: "Fire track",
  },
  {
    label: "Firetrail",
    value: "Firetrail",
  },
  {
    label: "Flat",
    value: "Flat",
  },
  {
    label: "Follow",
    value: "Follow",
  },
  {
    label: "Footway",
    value: "Footway",
  },
  {
    label: "Foreshore",
    value: "Foreshore",
  },
  {
    label: "Formation",
    value: "Formation",
  },
  {
    label: "Freeway",
    value: "Freeway",
  },
  {
    label: "Front",
    value: "Front",
  },
  {
    label: "Frontage",
    value: "Frontage",
  },
  {
    label: "Gap",
    value: "Gap",
  },
  {
    label: "Garden",
    value: "Garden",
  },
  {
    label: "Gardens",
    value: "Gardens",
  },
  {
    label: "Gate",
    value: "Gate",
  },
  {
    label: "Gates",
    value: "Gates",
  },
  {
    label: "Glade",
    value: "Glade",
  },
  {
    label: "Glen",
    value: "Glen",
  },
  {
    label: "Grange",
    value: "Grange",
  },
  {
    label: "Green",
    value: "Green",
  },
  {
    label: "Ground",
    value: "Ground",
  },
  {
    label: "Grove",
    value: "Grove",
  },
  {
    label: "Gully",
    value: "Gully",
  },
  {
    label: "Heights",
    value: "Heights",
  },
  {
    label: "Highroad",
    value: "Highroad",
  },
  {
    label: "Highway",
    value: "Highway",
  },
  {
    label: "Hill",
    value: "Hill",
  },
  {
    label: "Interchange",
    value: "Interchange",
  },
  {
    label: "Intersection",
    value: "Intersection",
  },
  {
    label: "Junction",
    value: "Junction",
  },
  {
    label: "Key",
    value: "Key",
  },
  {
    label: "Landing",
    value: "Landing",
  },
  {
    label: "Lane",
    value: "Lane",
  },
  {
    label: "Laneway",
    value: "Laneway",
  },
  {
    label: "Lees",
    value: "Lees",
  },
  {
    label: "Line",
    value: "Line",
  },
  {
    label: "Link",
    value: "Link",
  },
  {
    label: "Little",
    value: "Little",
  },
  {
    label: "Lookout",
    value: "Lookout",
  },
  {
    label: "Loop",
    value: "Loop",
  },
  {
    label: "Lower",
    value: "Lower",
  },
  {
    label: "Mall",
    value: "Mall",
  },
  {
    label: "Meander",
    value: "Meander",
  },
  {
    label: "Mew",
    value: "Mew",
  },
  {
    label: "Mews",
    value: "Mews",
  },
  {
    label: "Motorway",
    value: "Motorway",
  },
  {
    label: "Mount",
    value: "Mount",
  },
  {
    label: "Nook",
    value: "Nook",
  },
  {
    label: "Outlook",
    value: "Outlook",
  },
  {
    label: "Parade",
    value: "Parade",
  },
  {
    label: "Park",
    value: "Park",
  },
  {
    label: "Parklands",
    value: "Parklands",
  },
  {
    label: "Parkway",
    value: "Parkway",
  },
  {
    label: "Part",
    value: "Part",
  },
  {
    label: "Pass",
    value: "Pass",
  },
  {
    label: "Passage",
    value: "Passage",
  },
  {
    label: "Path",
    value: "Path",
  },
  {
    label: "Pathway",
    value: "Pathway",
  },
  {
    label: "Piazza",
    value: "Piazza",
  },
  {
    label: "Place",
    value: "Place",
  },
  {
    label: "Plateau",
    value: "Plateau",
  },
  {
    label: "Plaza",
    value: "Plaza",
  },
  {
    label: "Pocket",
    value: "Pocket",
  },
  {
    label: "Point",
    value: "Point",
  },
  {
    label: "Port",
    value: "Port",
  },
  {
    label: "Promenade",
    value: "Promenade",
  },
  {
    label: "Quad",
    value: "Quad",
  },
  {
    label: "Quadrangle",
    value: "Quadrangle",
  },
  {
    label: "Quadrant",
    value: "Quadrant",
  },
  {
    label: "Quay",
    value: "Quay",
  },
  {
    label: "Quays",
    value: "Quays",
  },
  {
    label: "Ramble",
    value: "Ramble",
  },
  {
    label: "Ramp",
    value: "Ramp",
  },
  {
    label: "Range",
    value: "Range",
  },
  {
    label: "Reach",
    value: "Reach",
  },
  {
    label: "Reserve",
    value: "Reserve",
  },
  {
    label: "Rest",
    value: "Rest",
  },
  {
    label: "Retreat",
    value: "Retreat",
  },
  {
    label: "Ride",
    value: "Ride",
  },
  {
    label: "Ridge",
    value: "Ridge",
  },
  {
    label: "Ridgeway",
    value: "Ridgeway",
  },
  {
    label: "Right of way",
    value: "Right of way",
  },
  {
    label: "Ring",
    value: "Ring",
  },
  {
    label: "Rise",
    value: "Rise",
  },
  {
    label: "River",
    value: "River",
  },
  {
    label: "Riverway",
    value: "Riverway",
  },
  {
    label: "Riviera",
    value: "Riviera",
  },
  {
    label: "Roads",
    value: "Roads",
  },
  {
    label: "Roadside",
    value: "Roadside",
  },
  {
    label: "Roadway",
    value: "Roadway",
  },
  {
    label: "Ronde",
    value: "Ronde",
  },
  {
    label: "Rosebowl",
    value: "Rosebowl",
  },
  {
    label: "Rotary",
    value: "Rotary",
  },
  {
    label: "Round",
    value: "Round",
  },
  {
    label: "Route",
    value: "Route",
  },
  {
    label: "Row",
    value: "Row",
  },
  {
    label: "Rue",
    value: "Rue",
  },
  {
    label: "Run",
    value: "Run",
  },
  {
    label: "Service way",
    value: "Service way",
  },
  {
    label: "Siding",
    value: "Siding",
  },
  {
    label: "Slope",
    value: "Slope",
  },
  {
    label: "Sound",
    value: "Sound",
  },
  {
    label: "Spur",
    value: "Spur",
  },
  {
    label: "Square",
    value: "Square",
  },
  {
    label: "Stairs",
    value: "Stairs",
  },
  {
    label: "State highway",
    value: "State highway",
  },
  {
    label: "Steps",
    value: "Steps",
  },
  {
    label: "Strand",
    value: "Strand",
  },
  {
    label: "Strip",
    value: "Strip",
  },
  {
    label: "Subway",
    value: "Subway",
  },
  {
    label: "Tarn",
    value: "Tarn",
  },
  {
    label: "Terrace",
    value: "Terrace",
  },
  {
    label: "Thoroughfare",
    value: "Thoroughfare",
  },
  {
    label: "Tollway",
    value: "Tollway",
  },
  {
    label: "Top",
    value: "Top",
  },
  {
    label: "Tor",
    value: "Tor",
  },
  {
    label: "Towers",
    value: "Towers",
  },
  {
    label: "Track",
    value: "Track",
  },
  {
    label: "Trail",
    value: "Trail",
  },
  {
    label: "Trailer",
    value: "Trailer",
  },
  {
    label: "Triangle",
    value: "Triangle",
  },
  {
    label: "Trunkway",
    value: "Trunkway",
  },
  {
    label: "Turn",
    value: "Turn",
  },
  {
    label: "Underpass",
    value: "Underpass",
  },
  {
    label: "Upper",
    value: "Upper",
  },
  {
    label: "Vale",
    value: "Vale",
  },
  {
    label: "Viaduct",
    value: "Viaduct",
  },
  {
    label: "View",
    value: "View",
  },
  {
    label: "Villas",
    value: "Villas",
  },
  {
    label: "Vista",
    value: "Vista",
  },
  {
    label: "Wade",
    value: "Wade",
  },
  {
    label: "Walk",
    value: "Walk",
  },
  {
    label: "Walkway",
    value: "Walkway",
  },
  {
    label: "Way",
    value: "Way",
  },
  {
    label: "Wharf",
    value: "Wharf",
  },
  {
    label: "Wynd",
    value: "Wynd",
  },
  {
    label: "Yard",
    value: "Yard",
  },
];

export const commonStreetTypes = [
  { value: "AVE", label: "Avenue" },
  { value: "BVD", label: "Boulevard" },
  { value: "CT", label: "Court" },
  { value: "DR", label: "Drive" },
  { value: "RD", label: "Road" },
  { value: "ST", label: "Street" },
];

export const alphabeticalStreetTypes = [
  { value: "ACCS", label: "Access" },
  { value: "ACRE", label: "Acre" },
  { value: "ALLY", label: "Alley" },
  { value: "ALWY", label: "Alleyway" },
  { value: "AMBL", label: "Amble" },
  { value: "ANCG", label: "Anchorage" },
  { value: "ANX", label: "Annex" },
  { value: "APP", label: "Approach" },
  { value: "ARC", label: "Arcade" },
  { value: "ARTL", label: "Arterial" },
  { value: "ART", label: "Artery" },
  { value: "BA", label: "Banan" },
  { value: "BANK", label: "Bank" },
  { value: "BASN", label: "Basin" },
  { value: "BAY", label: "Bay" },
  { value: "BCH", label: "Beach" },
  { value: "BEND", label: "Bend" },
  { value: "BLK", label: "Block" },
  { value: "BWLK", label: "Boardwalk" },
  { value: "BVDE", label: "Boulevarde" },
  { value: "BOWL", label: "Bowl" },
  { value: "BRCE", label: "Brace" },
  { value: "BRAE", label: "Brae" },
  { value: "BRAN", label: "Branch" },
  { value: "BRK", label: "Break" },
  { value: "BRET", label: "Brett" },
  { value: "BDGE", label: "Bridge" },
  { value: "BDWY", label: "Broadway" },
  { value: "BROW", label: "Brow" },
  { value: "BYPA", label: "Bypass" },
  { value: "BYWY", label: "Byway" },
  { value: "CAUS", label: "Causeway" },
  { value: "CTR", label: "Centre" },
  { value: "CNWY", label: "Centreway" },
  { value: "CH", label: "Chase" },
  { value: "CIR", label: "Circle" },
  { value: "CLT", label: "Circlet" },
  { value: "CCT", label: "Circuit" },
  { value: "CRCS", label: "Circus" },
  { value: "CL", label: "Close" },
  { value: "CLR", label: "Cluster" },
  { value: "CLDE", label: "Colonnade" },
  { value: "CMMN", label: "Common" },
  { value: "CNCD", label: "Concord" },
  { value: "CON", label: "Concourse" },
  { value: "CNN", label: "Connection" },
  { value: "CPS", label: "Copse" },
  { value: "CNR", label: "Corner" },
  { value: "CSO", label: "Corso" },
  { value: "CRSE", label: "Course" },
  { value: "CTYD", label: "Courtyard" },
  { value: "COVE", label: "Cove" },
  { value: "CRES", label: "Crescent" },
  { value: "CRST", label: "Crest" },
  { value: "CRF", label: "Crief" },
  { value: "CRK", label: "Crook" },
  { value: "CRSS", label: "Cross" },
  { value: "CRSG", label: "Crossing" },
  { value: "CRD", label: "Crossroad" },
  { value: "COWY", label: "Crossway" },
  { value: "CUWY", label: "Cruiseway" },
  { value: "CDS", label: "Cul-de-sac" },
  { value: "CUT", label: "Cut" },
  { value: "CTTG", label: "Cutting" },
  { value: "DALE", label: "Dale" },
  { value: "DASH", label: "Dash" },
  { value: "DELL", label: "Dell" },
  { value: "DENE", label: "Dene" },
  { value: "DEVN", label: "Deviation" },
  { value: "DIP", label: "Dip" },
  { value: "DSTR", label: "Distributor" },
  { value: "DIV", label: "Divide" },
  { value: "DOCK", label: "Dock" },
  { value: "DOM", label: "Domain" },
  { value: "DOWN", label: "Down" },
  { value: "DWNS", label: "Downs" },
  { value: "DRWY", label: "Driveway" },
  { value: "ESMT", label: "Easement" },
  { value: "EDGE", label: "Edge" },
  { value: "ELB", label: "Elbow" },
  { value: "END", label: "End" },
  { value: "ENT", label: "Entrance" },
  { value: "ESP", label: "Esplanade" },
  { value: "EST", label: "Estate" },
  { value: "EXP", label: "Expressway" },
  { value: "EXTN", label: "Extension" },
  { value: "FAWY", label: "Fairway" },
  { value: "FTRK", label: "Fire Track" },
  { value: "FBRK", label: "Firebreak" },
  { value: "FLNE", label: "Fireline" },
  { value: "FITR", label: "Firetrail" },
  { value: "FLAT", label: "Flat" },
  { value: "FLTS", label: "Flats" },
  { value: "FOLW", label: "Follow" },
  { value: "FTWY", label: "Footway" },
  { value: "FORD", label: "Ford" },
  { value: "FSHR", label: "Foreshore" },
  { value: "FK", label: "Fork" },
  { value: "FORM", label: "Formation" },
  { value: "FWY", label: "Freeway" },
  { value: "FRNT", label: "Front" },
  { value: "FRTG", label: "Frontage" },
  { value: "GAP", label: "Gap" },
  { value: "GDN", label: "Garden" },
  { value: "GDNS", label: "Gardens" },
  { value: "GTE", label: "Gate" },
  { value: "GTES", label: "Gates" },
  { value: "GTWY", label: "Gateway" },
  { value: "GLD", label: "Glade" },
  { value: "GLEN", label: "Glen" },
  { value: "GRA", label: "Grange" },
  { value: "GRN", label: "Green" },
  { value: "GRND", label: "Ground" },
  { value: "GR", label: "Grove" },
  { value: "GLY", label: "Gully" },
  { value: "HRBR", label: "Harbour" },
  { value: "HVN", label: "Haven" },
  { value: "HETH", label: "Heath" },
  { value: "HTS", label: "Heights" },
  { value: "HRD", label: "Highroad" },
  { value: "HWY", label: "Highway" },
  { value: "HILL", label: "Hill" },
  { value: "HLLW", label: "Hollow" },
  { value: "HUB", label: "Hub" },
  { value: "INLT", label: "Inlet" },
  { value: "INTG", label: "Interchange" },
  { value: "INTN", label: "Intersection" },
  { value: "ISLD", label: "Island" },
  { value: "JNC", label: "Junction" },
  { value: "KEY", label: "Key" },
  { value: "KEYS", label: "Keys" },
  { value: "KNOL", label: "Knoll" },
  { value: "LADR", label: "Ladder" },
  { value: "LDG", label: "Landing" },
  { value: "LANE", label: "Lane" },
  { value: "LNWY", label: "Laneway" },
  { value: "LEAD", label: "Lead" },
  { value: "LEDR", label: "Leader" },
  { value: "LEES", label: "Lees" },
  { value: "LINE", label: "Line" },
  { value: "LINK", label: "Link" },
  { value: "LT", label: "Little" },
  { value: "LKT", label: "Lookout" },
  { value: "LOOP", label: "Loop" },
  { value: "LWR", label: "Lower" },
  { value: "LYNN", label: "Lynne" },
  { value: "MALL", label: "Mall" },
  { value: "MANR", label: "Manor" },
  { value: "MART", label: "Mart" },
  { value: "MEAD", label: "Mead" },
  { value: "MNDR", label: "Meander" },
  { value: "MEW", label: "Mew" },
  { value: "MEWS", label: "Mews" },
  { value: "MILE", label: "Mile" },
  { value: "MWY", label: "Motorway" },
  { value: "MT", label: "Mount" },
  { value: "NOOK", label: "Nook" },
  { value: "NTH", label: "North" },
  { value: "NULL", label: "Null" },
  { value: "OTLT", label: "Outlet" },
  { value: "OTLK", label: "Outlook" },
  { value: "OVAL", label: "Oval" },
  { value: "PLMS", label: "Palms" },
  { value: "PDE", label: "Parade" },
  { value: "PRDS", label: "Paradise" },
  { value: "PARK", label: "Park" },
  { value: "PKLD", label: "Parklands" },
  { value: "PKWY", label: "Parkway" },
  { value: "PART", label: "Part" },
  { value: "PASS", label: "Pass" },
  { value: "PSGE", label: "Passage" },
  { value: "PATH", label: "Path" },
  { value: "PHWY", label: "Pathway" },
  { value: "PSLA", label: "Peninsula" },
  { value: "PIAZ", label: "Piazza" },
  { value: "PL", label: "Place" },
  { value: "PLAT", label: "Plateau" },
  { value: "PLZA", label: "Plaza" },
  { value: "PKT", label: "Pocket" },
  { value: "PNT", label: "Point" },
  { value: "PORT", label: "Port" },
  { value: "PREC", label: "Precinct" },
  { value: "PROM", label: "Promenade" },
  { value: "PRST", label: "Pursuit" },
  { value: "QUAD", label: "Quad" },
  { value: "QDGL", label: "Quadrangle" },
  { value: "QDRT", label: "Quadrant" },
  { value: "QY", label: "Quay" },
  { value: "QYS", label: "Quays" },
  { value: "RMBL", label: "Ramble" },
  { value: "RAMP", label: "Ramp" },
  { value: "RNGE", label: "Range" },
  { value: "RCH", label: "Reach" },
  { value: "REEF", label: "Reef" },
  { value: "RES", label: "Reserve" },
  { value: "REST", label: "Rest" },
  { value: "RTT", label: "Retreat" },
  { value: "RTRN", label: "Return" },
  { value: "RIDE", label: "Ride" },
  { value: "RDGE", label: "Ridge" },
  { value: "RGWY", label: "Ridgeway" },
  { value: "ROWY", label: "Right of Way" },
  { value: "RING", label: "Ring" },
  { value: "RISE", label: "Rise" },
  { value: "RSNG", label: "Rising" },
  { value: "RVR", label: "River" },
  { value: "RVWY", label: "Riverway" },
  { value: "RVRA", label: "Riviera" },
  { value: "RDS", label: "Roads" },
  { value: "RDSD", label: "Roadside" },
  { value: "RDWY", label: "Roadway" },
  { value: "RNDE", label: "Ronde" },
  { value: "RSBL", label: "Rosebowl" },
  { value: "RTY", label: "Rotary" },
  { value: "RND", label: "Round" },
  { value: "RTE", label: "Route" },
  { value: "ROW", label: "Row" },
  { value: "ROWE", label: "Rowe" },
  { value: "RUE", label: "Rue" },
  { value: "RUN", label: "Run" },
  { value: "SWY", label: "Service Way" },
  { value: "SHUN", label: "Shun" },
  { value: "SDNG", label: "Siding" },
  { value: "SKLN", label: "Skyline" },
  { value: "SLPE", label: "Slope" },
  { value: "SND", label: "Sound" },
  { value: "STH", label: "South" },
  { value: "SPUR", label: "Spur" },
  { value: "SQ", label: "Square" },
  { value: "STRS", label: "Stairs" },
  { value: "SHWY", label: "State Highway" },
  { value: "STPS", label: "Steps" },
  { value: "STRT", label: "Straight" },
  { value: "STAI", label: "Strait" },
  { value: "STRA", label: "Strand" },
  { value: "STRP", label: "Strip" },
  { value: "SBWY", label: "Subway" },
  { value: "TARN", label: "Tarn" },
  { value: "TCE", label: "Terrace" },
  { value: "THOR", label: "Thoroughfare" },
  { value: "THRU", label: "Throughway" },
  { value: "TLWY", label: "Tollway" },
  { value: "TOP", label: "Top" },
  { value: "TOR", label: "Tor" },
  { value: "TWRS", label: "Towers" },
  { value: "TRK", label: "Track" },
  { value: "TRL", label: "Trail" },
  { value: "TRLR", label: "Trailer" },
  { value: "TMWY", label: "Tramway" },
  { value: "TVSE", label: "Traverse" },
  { value: "TRI", label: "Triangle" },
  { value: "TKWY", label: "Trunkway" },
  { value: "TUNL", label: "Tunnel" },
  { value: "TURN", label: "Turn" },
  { value: "UPAS", label: "Underpass" },
  { value: "UPR", label: "Upper" },
  { value: "VALE", label: "Vale" },
  { value: "VLLY", label: "Valley" },
  { value: "VDCT", label: "Viaduct" },
  { value: "VIEW", label: "View" },
  { value: "VWS", label: "Views" },
  { value: "VLL", label: "Villa" },
  { value: "VLGE", label: "Village" },
  { value: "VLLS", label: "Villas" },
  { value: "VSTA", label: "Vista" },
  { value: "VUE", label: "Vue" },
  { value: "WADE", label: "Wade" },
  { value: "WALK", label: "Walk" },
  { value: "WKWY", label: "Walkway" },
  { value: "WTRS", label: "Waters" },
  { value: "WTWY", label: "Waterway" },
  { value: "WAY", label: "Way" },
  { value: "WHRF", label: "Wharf" },
  { value: "WOOD", label: "Wood" },
  { value: "WDS", label: "Woods" },
  { value: "WYND", label: "Wynd" },
  { value: "YARD", label: "Yard" },
];

export const streetTypeOptions = [
  ...commonStreetTypes,
  ...alphabeticalStreetTypes.sort((a, b) => a.label.localeCompare(b.label)),
];

export const streetSuffixes = [
  {
    label: "Central",
    value: "Central",
  },
  {
    label: "East",
    value: "East",
  },
  {
    label: "Extension",
    value: "Extension",
  },
  {
    label: "Lower",
    value: "Lower",
  },
  {
    label: "North",
    value: "North",
  },
  {
    label: "North West",
    value: "North West",
  },
  {
    label: "North East",
    value: "North East",
  },
  {
    label: "South",
    value: "South",
  },
  {
    label: "South East",
    value: "South East",
  },
  {
    label: "South West",
    value: "South West",
  },
  {
    label: "Upper",
    value: "Upper",
  },
  {
    label: "West",
    value: "West",
  },
];

export const australianStates = [
  {
    label: "ACT",
    value: "ACT",
  },
  {
    label: "NSW",
    value: "NSW",
  },
  {
    label: "QLD",
    value: "QLD",
  },
  {
    label: "SA",
    value: "SA",
  },
  {
    label: "TAS",
    value: "TAS",
  },
  {
    label: "VIC",
    value: "VIC",
  },
  {
    label: "WA",
    value: "WA",
  },
  {
    label: "NT",
    value: "NT",
  },
];

export const connectableAustralianStates = [
  {
    label: "ACT",
    value: "ACT",
  },
  {
    label: "NSW",
    value: "NSW",
  },
  {
    label: "QLD",
    value: "QLD",
  },
  {
    label: "SA",
    value: "SA",
  },
  {
    label: "VIC",
    value: "VIC",
  },
];

export const allAustralianStates = [
  { label: "ACT", value: "ACT" },
  { label: "NSW", value: "NSW" },
  { label: "QLD", value: "QLD" },
  { label: "SA", value: "SA" },
  { label: "VIC", value: "VIC" },
  { label: "WA", value: "WA" },
  { label: "TAS", value: "TAS" },
  { label: "NT", value: "NT" },
];

export const poBoxTypes = [
  {
    label: "Care PO",
    value: "carePo",
    optionalPoNumber: true, // No associated postal delivery number
  },
  {
    label: "GPO Box",
    value: "gpoBox",
  },
  {
    label: "Locked Bag",
    value: "lockedBag",
  },
  {
    label: "PO Box",
    value: "poBox",
  },
  {
    label: "Private Bag",
    value: "privateBag",
  },
  {
    label: "CPA",
    value: "CPA",
    optionalPoNumber: true, // No associated postal delivery number
  },
  {
    label: "CMA",
    value: "CMA",
    optionalPoNumber: true, // No associated postal delivery number
  },
  {
    label: "CMB",
    value: "CMB",
    optionalPoNumber: true, // Optional according to Australian standards
  },
  {
    label: "MS",
    value: "MS",
  },
  {
    label: "RMB",
    value: "RMB",
  },
  {
    label: "RMS",
    value: "RMS",
  },
  {
    label: "RSD",
    value: "RSD",
  },
];
